import {
    dueDateDisplayText,
    itemDueToday,
    itemPastDue,
    itemCompleted,
    itemCompletedOnDate,
} from '../dueDates.locstring.json';
import { observableToday } from 'owa-observable-datetime';
import {
    OwaDate,
    differenceInCalendarDays,
    startOfMonth,
    addYears,
    addMonths,
    endOfMonth,
    isWithinRange,
    formatShortMonthDayYear,
    formatMonthDay,
    formatMonthDayYear,
} from 'owa-datetime';
import loc from 'owa-localize';

export default function getDueDateText(
    date: OwaDate,
    isCompleted: boolean,
    hideDateOnCompletion?: boolean
) {
    const today = observableToday();
    const diff = differenceInCalendarDays(date, today);

    if (hideDateOnCompletion && isCompleted) {
        return loc(itemCompleted);
    }

    // For "due today", we don't need year.
    if (diff == 0) {
        return loc(itemDueToday, formatMonthDay(date));
    }

    // Past and future dates will show the year if they are far enough.
    // We use one year in the past and future as cut-off dates,
    // adjusted to the end and start of the month, to reduce the chance of confusion.
    // The fact that we show "Past due" next to past dates helps resolve possible ambiguities
    // but it also means we need a short date string. Future dates are fine being long strings.
    // Ex: if today is somewhere in March 2020 then:
    //     - if date is <= Mar 31, 2019, show the year.
    //     - if Apr 1, 2019 <= date <= February 28, 2021, don't show the year.
    //     - if date is >= Feb 28, 2021, show the year.
    const startOfThisMonth = startOfMonth(today);
    const endOfLastMonth = endOfMonth(addMonths(startOfThisMonth, -1));
    const startOfNextMonth = addMonths(startOfThisMonth, 1);
    const past = addYears(startOfNextMonth, -1);
    const future = addYears(endOfLastMonth, 1);
    const formatWithYear = diff < 0 ? formatShortMonthDayYear : formatMonthDayYear;
    const formatDate = isWithinRange(date, past, future) ? formatMonthDay : formatWithYear;
    const dateStr = formatDate(date);

    if (isCompleted) {
        return loc(itemCompletedOnDate, dateStr);
    }

    return diff < 0 ? loc(itemPastDue, dateStr) : loc(dueDateDisplayText, dateStr);
}
